import { connect } from 'react-redux';

import { PageComponent } from '../../components/PageComponent';
import { IApplicationState } from '../../types/redux';

export function mapStateToProps(state: IApplicationState) {
  return {
    deviceType: state.page.deviceType,
  };
}

export const PageContainer = connect(mapStateToProps)(PageComponent);
